module.exports = __webpack_public_path__ + "ClientApp/images/content/mobile/veterinary_hospice.png";